module.exports = __webpack_public_path__ + "static/media/payroll.74cf8611.svg";